import { render, staticRenderFns } from "./visit-returnc-case-manage.vue?vue&type=template&id=e9215c34&scoped=true"
import script from "./visit-returnc-case-manage.vue?vue&type=script&lang=ts"
export * from "./visit-returnc-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9215c34",
  null
  
)

export default component.exports